export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s n\'a pas été sélectionné';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s ne peut pas rester vide';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s est un champ obligatoire';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s n\'a pas été complété correctement';
                break;

            case 'opt-in':
                translation = 'Veuillez cocher la case pour continuer';
                break;

            default:
                translation = 'Ce champ n\'a pas été complété correctement';
                break;
        }

        return translation;
    }
}
